"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReward = void 0;
var react_1 = require("react");
var play_api_1 = require("@l2p/play-api");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var prepareBonusType = function (bonus, currency) {
    var _a, _b, _c, _d, _e;
    var freespins = (_b = (_a = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _a === void 0 ? void 0 : _a.find(function (item) {
        return item.type === play_api_1.BonusRewardType.FreeRounds ||
            item.type === play_api_1.BonusRewardType.RepeatableFreeRounds;
    })) === null || _b === void 0 ? void 0 : _b.freeRoundsCount;
    var amount = (_e = (_d = (_c = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _c === void 0 ? void 0 : _c.find(function (item) { return item.type === play_api_1.BonusRewardType.Relative; })) === null || _d === void 0 ? void 0 : _d.addedToBalance) === null || _e === void 0 ? void 0 : _e.find(function (item) { return item.currency === currency; });
    return {
        freespins: freespins,
        amount: amount ? "".concat(amount.amount, " ").concat(amount.currency) : undefined,
    };
};
var useReward = function (reward) {
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var t = (0, next_intl_1.useTranslations)('lottery');
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!reward)
            return null;
        if (((_a = reward === null || reward === void 0 ? void 0 : reward.reward) === null || _a === void 0 ? void 0 : _a.type) === play_api_1.LotteryRewardType.Cash)
            return "".concat((_c = Number(((_b = reward === null || reward === void 0 ? void 0 : reward.reward) === null || _b === void 0 ? void 0 : _b.amount) || 0)) === null || _c === void 0 ? void 0 : _c.toFixed(2), " ").concat(currentCurrency);
        if (((_d = reward === null || reward === void 0 ? void 0 : reward.reward) === null || _d === void 0 ? void 0 : _d.type) === play_api_1.LotteryRewardType.FreeRounds)
            return "".concat(reward.reward.amount, " ").concat(t('fs').toLocaleUpperCase());
        if (((_e = reward === null || reward === void 0 ? void 0 : reward.reward) === null || _e === void 0 ? void 0 : _e.type) === play_api_1.LotteryRewardType.Stuff)
            return "".concat(reward.reward.amount, " ").concat(t('fs').toLocaleUpperCase());
        if (((_f = reward === null || reward === void 0 ? void 0 : reward.reward) === null || _f === void 0 ? void 0 : _f.type) === play_api_1.LotteryRewardType.Bonus) {
            var bonus = prepareBonusType(((_g = reward === null || reward === void 0 ? void 0 : reward.reward) === null || _g === void 0 ? void 0 : _g.bonus) || {}, currentCurrency);
            return bonus
                ? "".concat(bonus.percents || '', " ").concat((bonus === null || bonus === void 0 ? void 0 : bonus.amount) ? (_h = Number((bonus === null || bonus === void 0 ? void 0 : bonus.amount) || 0)) === null || _h === void 0 ? void 0 : _h.toFixed(2) : '', " ").concat((bonus === null || bonus === void 0 ? void 0 : bonus.freespins)
                    ? (bonus === null || bonus === void 0 ? void 0 : bonus.amount)
                        ? '+ '
                        : '' + (bonus === null || bonus === void 0 ? void 0 : bonus.freespins) + ' ' + t('fs')
                    : '')
                : '';
        }
    }, [currentCurrency, reward, t]);
};
exports.useReward = useReward;
